<span class="ql-formats">
    <select *ngIf="options.includes('size')" class="ql-size">
        <option value="huge">Heading</option>
        <option value="large">Subheading</option>
        <option selected></option>
    </select>
    <select *ngIf="options.includes('font')" class="ql-font">
        <option selected>Sans Serif</option>
        <option value="serif">Serif</option>
        <option value="monospace">Monospace</option>
    </select>
</span>
<span class="ql-formats">
    <select *ngIf="options.includes('colorFnt')" title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
        <option value="#000000"></option>
        <option value="#e60000"></option>
        <option value="#ff9900"></option>
        <option value="#ffff00"></option>
        <option value="#008a00"></option>
        <option value="#0066cc"></option>
        <option value="#9933ff"></option>
        <option value="#facccc"></option>
        <option value="#ffebcc"></option>
        <option value="#ffffcc"></option>
        <option value="#cce8cc"></option>
        <option value="#cce0f5"></option>
        <option value="#ebd6ff"></option>
        <option value="#bbbbbb"></option>
        <option value="#f06666"></option>
        <option value="#ffc266"></option>
        <option value="#ffff66"></option>
        <option value="#66b966"></option>
        <option value="#66a3e0"></option>
        <option value="#c285ff"></option>
        <option value="#888888"></option>
        <option value="#a10000"></option>
        <option value="#b26b00"></option>
        <option value="#b2b200"></option>
        <option value="#006100"></option>
        <option value="#0047b2"></option>
        <option value="#6b24b2"></option>
        <option value="#444444"></option>
        <option value="#5c0000"></option>
        <option value="#663d00"></option>
        <option value="#666600"></option>
        <option value="#003700"></option>
        <option value="#002966"></option>
        <option value="#3d1466"></option>
    </select>
    <select *ngIf="options.includes('colorBg')" title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
        <option value="#000000"></option>
        <option value="#e60000"></option>
        <option value="#ff9900"></option>
        <option value="#ffff00"></option>
        <option value="#008a00"></option>
        <option value="#0066cc"></option>
        <option value="#9933ff"></option>
        <option value="#facccc"></option>
        <option value="#ffebcc"></option>
        <option value="#ffffcc"></option>
        <option value="#cce8cc"></option>
        <option value="#cce0f5"></option>
        <option value="#ebd6ff"></option>
        <option value="#bbbbbb"></option>
        <option value="#f06666"></option>
        <option value="#ffc266"></option>
        <option value="#ffff66"></option>
        <option value="#66b966"></option>
        <option value="#66a3e0"></option>
        <option value="#c285ff"></option>
        <option value="#888888"></option>
        <option value="#a10000"></option>
        <option value="#b26b00"></option>
        <option value="#b2b200"></option>
        <option value="#006100"></option>
        <option value="#0047b2"></option>
        <option value="#6b24b2"></option>
        <option value="#444444"></option>
        <option value="#5c0000"></option>
        <option value="#663d00"></option>
        <option value="#666600"></option>
        <option value="#003700"></option>
        <option value="#002966"></option>
        <option value="#3d1466"></option>
    </select>
</span>
<span class="ql-formats">
    <button *ngIf="options.includes('bold')" class="ql-bold" aria-label="Bold"></button>
    <button *ngIf="options.includes('italic')" class="ql-italic" aria-label="Italic"></button>
    <button *ngIf="options.includes('underline')" class="ql-underline" aria-label="Underline"></button>
</span>
<span class="ql-formats">
    <button *ngIf="options.includes('orderer')" class="ql-list" aria-label="Orderer List" value="ordered"></button>
    <button *ngIf="options.includes('unorderer')" class="ql-list" aria-label="Unorderer List" value="bullet"></button>
    <select *ngIf="options.includes('align')" title="Text Alignment" class="ql-align" >
        <option selected>Gauche</option>
        <option value="center" label="Center"></option>
        <option value="right" label="Right"></option>
        <option value="justify" label="Justify"></option>
    </select>    
</span>
<span class="ql-formats">
    <button *ngIf="options.includes('link')" class="ql-link" aria-label="Insert Link"></button>
    <button *ngIf="options.includes('image')" class="ql-image" aria-label="Image"></button>
    <button *ngIf="options.includes('code')" class="ql-code-block" aria-label="Insert Code Block"></button>
</span>
<span class="ql-formats">
    <button *ngIf="options.includes('reset')" class="ql-clean" aria-label="Remove Styles"></button>
</span>